import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguageSwitch } from '../../i18n/hooks/useLanguageSwitch';
import { LANGUAGE_NAMES, SUPPORTED_LANGUAGES } from '../../i18n/constants/languages';
import type { SupportedLanguage } from '../../i18n/types/language';

const LanguageSwitcher = () => {
  const { currentLanguage, switchLanguage } = useLanguageSwitch();

  const handleLanguageChange = async (lang: SupportedLanguage) => {
    if (currentLanguage !== lang) {
      await switchLanguage(lang);
    }
  };

  return (
    <div className="relative group">
      <button className="flex items-center space-x-1 text-gray-600 hover:text-blue-600">
        <Globe className="h-5 w-5" />
        <span className="text-sm">{LANGUAGE_NAMES[currentLanguage as SupportedLanguage]}</span>
      </button>
      
      <div className="absolute right-0 mt-2 py-2 w-32 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 md:origin-top-right">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <button
            key={lang}
            onClick={() => handleLanguageChange(lang)}
            className={`block w-full px-4 py-2 text-left text-sm ${
              currentLanguage === lang ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            {LANGUAGE_NAMES[lang]}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;